import { SetStateAction, createContext } from "react";
import { AvailableTemplate } from "src/models/AvailableTemplates";
import { Instruction } from "src/models/Instruction";
import { UserProject } from "src/models/UserProjects";

export const NewTemplateDialogContext = createContext<[boolean, React.Dispatch<React.SetStateAction<boolean>>]>([
    false,
    () => console.warn("NewTemplateDialogContext not provided")
]);

export const SourceDialogContext = createContext<[boolean, React.Dispatch<React.SetStateAction<boolean>>]>([
    false,
    () => console.warn("SourceDialogContext not provided")
]);

export const SearchContext = createContext<[string, React.Dispatch<React.SetStateAction<string>>]>([
    "",
    () => console.warn("SearchContext not provided")
]);

export const ShowDeleteAlertContext = createContext<[boolean, React.Dispatch<React.SetStateAction<boolean>>]>([
    false,
    () => console.warn("ShowDeleteAlertContext not provided")
]);

export const TemplateGridSelectContext = createContext<
    [AvailableTemplate | undefined, (value: SetStateAction<AvailableTemplate | undefined>) => void]
>([undefined, () => console.warn("TemplateGridSelectContext not provided")]);

export const SourceDialogCurrentProjectContext = createContext<
    [UserProject | undefined, (value: SetStateAction<UserProject | undefined>) => void]
>([undefined, () => console.warn("TemplateGridSelectContext not provided")]);

export const NewTemplateInstructionsContext = createContext<
    [Instruction[], React.Dispatch<React.SetStateAction<Instruction[]>>]
>([[], () => console.warn("CurrentStepContext not provided")]);

export const InputInstructionHasDependency = createContext<[boolean, React.Dispatch<React.SetStateAction<boolean>>]>([
    false,
    () => console.warn("InputInstructionHasDependency not provided")
]);

export const DarkThemeContext = createContext(true);

export const SnContext = createContext("");
// contexts useful in the future
// export const ProjectContext = createContext<[UserProject[], React.Dispatch<React.SetStateAction<UserProject[]>>]>([[], () => console.warn("ProjectContext not provided")]);
// export const SettingsContext = createContext<[Settings, (value: SetStateAction<Settings>) => void]>([defaultSettings, () => console.warn("SettingsContext not provided")]);
